module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0158.jpg?v=3753b0f8";